import React, { FunctionComponent, useState } from 'react';
import moment, { Moment } from 'moment';
import { useTranslation } from 'react-i18next';
import TreasuryRow from './TreasuryRow';
import TurnoverDetails from './TurnoverDetails';
import { MonthlyData } from './types';

interface OwnProps {
  planned: number;
  total: number;
}

type Props = OwnProps;

const MonthlyTurnoverRow: FunctionComponent<Props> = ({ planned, total }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState<boolean>(false);
  const [dateStart, setDateStart] = useState<Moment>(moment());
  const [dateEnd, setDateEnd] = useState<Moment>(moment());

  const details = (o: string, t: string, month: MonthlyData, nextMonth: MonthlyData): void => {
    setDateStart(month.date);
    setDateEnd(nextMonth.date);
    setOpen(true);
  };

  return (
    <TreasuryRow
      label={t('treasuryTurnover')}
      planned={planned}
      gap={total - planned}
      monthKey="monthTurnover"
      total={total}
      onClick={details}
    >
      <TurnoverDetails
        open={open}
        close={(): void => setOpen(false)}
        dateStart={dateStart}
        dateEnd={moment(dateEnd).subtract(1, 'day')}
        display="turnover"
        label={t('treasuryTurnover')}
      />
    </TreasuryRow>
  );
};

export default MonthlyTurnoverRow;
